import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FileSignature } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/company-property`;

// Dashboard flag: company property receipts waiting for the current user's signature.
export default function PaperworkCard() {
  const [pending, setPending] = useState([]);
  const [retakes, setRetakes] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    axios.get(`${API}/my`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => { setPending(r.data.pending || []); setRetakes(r.data.retakes || []); }).catch(() => { setPending([]); setRetakes([]); });
  }, []);
  if (pending.length === 0 && retakes.length === 0) return null;
  const n = pending.reduce((s, a) => s + (a.items?.length || 0), 0);
  if (pending.length === 0) {
    const rn = retakes.reduce((s, r) => s + r.items.length, 0);
    return (
      <div data-testid="paperwork-card" className="rounded-xl border border-red-300 bg-white border-l-4 border-l-red-600 shadow-sm p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <FileSignature className="w-7 h-7 shrink-0 text-red-600" />
        <div className="flex-1 min-w-0">
          <p className="font-bold text-red-950" data-testid="paperwork-card-title">HR needs you to retake {rn === 1 ? 'a photo' : `${rn} photos`}</p>
          <p className="text-xs text-slate-600 truncate">{retakes.flatMap(r => r.items.map(i => `${i.type_label}: ${i.photo_reject_reason}`)).slice(0, 2).join(' · ')}</p>
        </div>
        <button onClick={() => navigate('/my-paperwork')} data-testid="paperwork-card-open" className="shrink-0 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-red-600 hover:bg-red-500 shadow-sm">Retake now</button>
      </div>
    );
  }
  return (
    <div data-testid="paperwork-card" className="rounded-xl border border-red-300 bg-white border-l-4 border-l-red-600 shadow-sm p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <FileSignature className="w-7 h-7 shrink-0 text-red-600" />
      <div className="flex-1 min-w-0">
        <p className="font-bold text-red-950" data-testid="paperwork-card-title">You have paperwork to sign</p>
        <p className="text-xs text-slate-600 truncate">
          {n} company item{n !== 1 ? 's' : ''} issued to you ({pending.flatMap(a => a.items.map(i => i.type_label)).slice(0, 4).join(', ')}) — confirm receipt and sign.
        </p>
      </div>
      <button onClick={() => navigate('/my-paperwork')} data-testid="paperwork-card-open"
        className="shrink-0 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-red-600 hover:bg-red-500 shadow-sm">Sign now</button>
    </div>
  );
}
